import Button from '@/app/components/common/Button'
import Popup from '@/app/components/common/Popup'
import Title from '@/app/components/common/Title'
import { Icons } from '@/app/components/ui/Icons'
import { SM_BREAKPOINT } from '@/app/constants'
import { useMediaQuery } from '@uidotdev/usehooks'
import classNames from 'classnames'
import { useTranslations } from 'next-intl'
import { FC, ReactNode } from 'react'
import { RemoveScroll } from 'react-remove-scroll'

interface LanguageAndCurrencyPopupProps {
	isOpen: boolean
	children: ReactNode
	onClose: () => void
	onSave: () => void
}

const LanguageAndCurrencyPopup: FC<LanguageAndCurrencyPopupProps> = ({
	isOpen,
	onClose,
	onSave,
	children,
}) => {
	const isMobile = useMediaQuery(SM_BREAKPOINT)
	const t = useTranslations('Header')

	return (
		<RemoveScroll enabled={isOpen && isMobile}>
			<Popup
				isOpen={isOpen}
				onClose={onClose}
				fullScreenMode
				className="w-screen min-h-screen fixed bg-text-100 left-0 top-0 flex flex-col"
				data-testid="language-currency-popup-mobile"
			>
				<div className="px-3 py-6 flex items-center relative">
					<button
						className="w-10 h-10 p-2"
						onClick={onClose}
						data-testid="language-currency-popup-close-btn"
					>
						<Icons.iconClose />
					</button>
					<Title level="5" bold className="text-left">
						{t('languageAndCurrency')}
					</Title>
				</div>
				<div className="flex flex-col justify-between grow">
					<div className="max-w-screen-md mx-auto w-full px-4">
						{children}
					</div>
				</div>
				<div className="sticky bottom-0 left-0 w-full bg-white shadow-[0_0_30px_0_rgba(0,0,0,0.08),0_-4px_12px_0_rgba(0,0,0,0.02)] p-4 z-50 flex flex-col items-center gap-2">
					<Button
						id="save-button"
						bold
						textColor="white"
						onClick={onSave}
						name="Save"
						data-testid="language-currency-save-btn"
						className={classNames(
							'!bg-dark-blue max-h-[52px] !rounded-full w-full flex justify-center fs-5 items-center gap-2.5 px-6 py-3 self-stretch !text-base leading-5 font-bold text-center'
						)}
					>
						{t('save')}
					</Button>
				</div>
			</Popup>
		</RemoveScroll>
	)
}

export default LanguageAndCurrencyPopup
